export const maxSize = 5 * 1048576;
